import React, {useEffect} from 'react';
import { WindowWithGigya } from '../../services/gigya';
import { getAssetUrl } from '../../utils/assetUrl';

const ProfileCompletionScreen: React.FC = () => {
    useEffect(() => {
        const win = window as unknown as WindowWithGigya;
        if (win.gigya?.accounts) {
            console.log('🧭 [FSL Router Debug] User missing customer number, triggering profile completion');
            win.gigya?.accounts?.showScreenSet?.({
              screenSet: 'CLP-RegistrationLogin',
              startScreen: 'fsl_profilecompletion',
              containerID: 'gigya-registration-container',
              lang: window.fsl_locale?.split('-')[0] ?? 'en',
              onAfterSubmit: ({ response }: any) => {
                if(response?.errorCode ===  0 && response?.status === "OK"){
                  window.location.reload();
                }
                else {
                  //Error handling will happen on Gigya side. 
                  console.error("Profile Completion Submition Failed:", response?.errorMessage)
                }
              },
            });
        }
    }, []);

  return (
    <div
      style={{ backgroundImage: `url(${getAssetUrl('Brand-Horizon_D.svg')})` }}
      className="bg-cover bg-center display-flex flex-col h-screen overflow-auto"
    >
      <div className="flex flex-col items-center justify-center min-h-[200px] text-center">
        <img src={getAssetUrl('images/hills-logo.svg')} alt="Hill's Icon" />
      </div>
      <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
        <div>
          <div
            id="gigya-registration-container"
            data-testid="gigya-registration-container"
            className="min-h-[300px]"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionScreen;